import { LayoutGrid, List } from 'lucide-react';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

export type CarViewMode = 'model' | 'variant';

interface ViewModeToggleProps {
  value: CarViewMode;
  onChange: (mode: CarViewMode) => void;
  className?: string;
}

export function ViewModeToggle({ value, onChange, className }: ViewModeToggleProps) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(v) => { if (v) onChange(v as CarViewMode); }}
      className={className}
      aria-label="Vælg visning"
    >
      <ToggleGroupItem
        value="model"
        aria-label="Vis modeller"
        className="gap-1.5 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground"
      >
        <LayoutGrid className="w-4 h-4" />
        <span className="text-sm font-medium">Modeller</span>
      </ToggleGroupItem>
      <ToggleGroupItem
        value="variant"
        aria-label="Vis varianter"
        className="gap-1.5 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground"
      >
        <List className="w-4 h-4" />
        <span className="text-sm font-medium">Varianter</span>
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
